module.exports = __webpack_public_path__ + "img/team3.a68afc11.png";